import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

export function exportToExcel({ data, naziv, station_id, startDate, endDate }) {
    if (!data || Object.keys(data).length === 0) return;
    // Map for Serbian column names
    const columnMap = {
        'Date and time': 'Datum i vreme',
        'temperatures': 'Temperatura vazduha [°C]',
        'precipitation': 'Padavine [mm]',
        'leaf_wetness': 'Vlažnost lista [%]',
        'humidity': 'Vlažnost vazduha [%]',
        'dew_point': 'Tačka rošenja [°C]',
        'vpd': 'Vazdušni deficit pritiska pare [kPa]',
        'deltat': 'Delta T [°C]',
        'soil_temperatures': 'Temperatura zemljišta [°C]',
        'soil_moistures': 'Vlažnost zemljišta [%]',
        'solar_radiation': 'Solarno zračenje [W/m²]',
        'wind_speed': 'Brzina vetra [m/s]',
        'wind_dir': 'Pravac vetra [°]',
        'wind_gust': 'Udar vetra [m/s]',
    };
    const { dates, ...rest } = data;
    let rows = [];
    if (Array.isArray(dates)) {
        for (let i = 0; i < dates.length; i++) {
            let row = { [columnMap['Date and time']]: dates[i] };
            Object.keys(rest).forEach(key => {
                // Try to translate, fallback to original key
                const serbianKey = columnMap[key] || key;
                if (Array.isArray(rest[key])) {
                    row[serbianKey] = rest[key][i] !== undefined ? rest[key][i] : '';
                } else {
                    row[serbianKey] = rest[key];
                }
            });
            rows.push(row);
        }
    } else {
        // fallback: just flatten all data
        let flatData = {};
        Object.keys(data).forEach(key => {
            const serbianKey = columnMap[key] || key;
            const value = data[key];
            flatData[serbianKey] = Array.isArray(value) ? value.join(', ') : value;
        });
        rows = [flatData];
    }
    const worksheet = XLSX.utils.json_to_sheet(rows);
    // Set column widths (20 chars for all columns)
    const headers = Object.keys(rows[0] || {});
    worksheet['!cols'] = headers.map(() => ({ wch: 15 }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'All Data');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    // Build filename: MeteoStationName_uid_startDate_endDate.xlsx
    const stationName = naziv || 'MeteoStation';
    const uid = station_id || 'unknown';
    const start = startDate ? moment(startDate).format('DD/MM/YYYY') : 'start';
    const end = endDate ? moment(endDate).format('DD/MM/YYYY') : 'end';
    const filename = `${stationName} (${uid}) ${start} - ${end}.xlsx`;
    saveAs(blob, filename);
}